import { createReducer, on, createFeature } from '@ngrx/store'
import { BankState } from './bank.state'
import {
  createBank,
  createBankFailure,
  createBankSuccess,
  deleteBank,
  deleteBankFailure,
  deleteBankSuccess,
  loadBanks,
  loadBanksFailure,
  loadBanksSuccess,
  updateBank,
  updateBankFailure,
  updateBankSuccess
} from './bank.actions'

export const initialState: BankState = {
  banks: [],
  loading: false,
  error: null
}

export const bankReducer = createReducer(
  initialState,
  on(loadBanks, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(loadBanksSuccess, (state, { banks }) => ({
    ...state,
    banks: banks,
    loading: false,
    error: null
  })),
  on(loadBanksFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(createBank, state => ({ ...state, loading: true })),
  on(createBankSuccess, (state, { bank }) => ({
    ...state,
    banks: [...state.banks, bank],
    loading: false
  })),
  on(createBankFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(updateBank, state => ({ ...state, loading: true })),
  on(updateBankSuccess, (state, { bank }) => ({
    ...state,
    bank,
    loading: false
  })),
  on(updateBankFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(deleteBank, (state, { id }) => ({
    ...state,
    banks: state.banks.map(bank => (String(bank.id) === id ? { ...bank, disabled: true } : bank))
  })),
  on(deleteBankSuccess, (state, { id }) => {
    // Update the business state to reflect that it is successfully deleted
    const updatedState = {
      ...state,
      banks: state.banks.filter(b => b.id !== id), // Remove the business from the list
      error: null
    }
    return updatedState
  }),
  on(deleteBankFailure, (state, { error }) => ({
    ...state,
    error
  }))
)

// Create the feature for the business state
export const bankFeature = createFeature({
  name: 'Bank', // Feature name
  reducer: bankReducer
})
export type { BankState }
// Export the feature's selectors
export const { name, reducer, selectBanks, selectLoading, selectError } = bankFeature
